'use strict';

const breakpoint = [
  '$rootScope',
  '$window',

  function ($rootScope, $window) {
    var windowEl = angular.element($window);
    var body = $window.document.body;
    var breakpoint = getBreakpoint();

    function triggerEvent() {
      $rootScope.$emit('breakpointChanged', breakpoint);
    }

    function getBreakpoint() {
      var otoBreakpoint = 'mobile';
      var oldBreakpoint = $window.getComputedStyle(body,':after').getPropertyValue('content').replace(/['"]*/g, '');

      try {
        if (oldBreakpoint.length === 0) {
          if ($window.matchMedia('(max-width: 739px)')) {
            otoBreakpoint;
          } else if ($window.matchMedia('(min-width: 1200px)')) {
            otoBreakpoint = 'desktop';
          } else if ($window.matchMedia('(min-width: 1024px)')) {
            otoBreakpoint = 'tablet-horizontal';
          } else if ($window.matchMedia('(min-width: 740px)')) {
            otoBreakpoint = 'tablet';
          }
        } else {
          otoBreakpoint = oldBreakpoint;
        }
      } catch(e) {
        //
      }

      return otoBreakpoint;
    }

    windowEl.on('resize', function () {
      $rootScope.$apply(function () {
        var newBreakpoint = getBreakpoint();

        if (newBreakpoint !== breakpoint) {
          breakpoint = newBreakpoint;
          triggerEvent();
        }
      });
    });

    return getBreakpoint;
  }
];

export default breakpoint;



// WEBPACK FOOTER //
// ./app/src/services/breakpoint.js